import { TUser } from '../../types/currentUser';
import { TReduxActions } from '../../types/redux';
import { EGetUserStatus } from '../../actions/user/types';

const defaultState: TUser = null;

export function userReducer(state: TUser = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EGetUserStatus.Succeed: {
      return action.payload;
    }

    default:
      return state;
  }
}
